import { render, staticRenderFns } from "./SelectTaskImportRequest.vue?vue&type=template&id=1b68faae"
import script from "./SelectTaskImportRequest.vue?vue&type=script&lang=js"
export * from "./SelectTaskImportRequest.vue?vue&type=script&lang=js"
import style0 from "./SelectTaskImportRequest.vue?vue&type=style&index=0&id=1b68faae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports